import { Typography } from '@mui/material'
import { LineChart } from '@mui/x-charts/LineChart'

const NetworkChart = ({ data, unitOfMeasure }) => {
  const chartData = data.map(d => ({
    x: new Date(d.x),
    y: d.y
  }))

  const values = data.map(d => d.y)

  const minY = Math.min(...values)
  const maxY = Math.max(...values)

  const padding = (maxY - minY) * 0.1

  return (
    <LineChart
      dataset={chartData}
      xAxis={[
        {
          dataKey: 'x',
          height: 90,
          scaleType: 'time',
          valueFormatter: value =>
            value.toLocaleString('it-IT', {
              day: '2-digit',
              month: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            }),
          tickLabelStyle: {
            angle: -90
          }
        }
      ]}
      yAxis={[
        {
          min: minY - padding,
          max: maxY + padding,
          width: 80
        }
      ]}
      series={[
        {
          dataKey: 'y',
          area: true,
          showMark: true,
          valueFormatter: value => `${value} ${unitOfMeasure}`
        }
      ]}
      height={400}
      margin={{ top: 10, right: 10, bottom: 50 }}
      slotProps={{
        tooltip: {
          trigger: 'axis',
          content: ({ axisValue, series }) => (
            <div
              style={{
                background: 'white',
                padding: '9px 12px',
                border: '1px solid #ccc'
              }}
            >
              <Typography variant="body2">
                <small>
                  {axisValue.toLocaleString('it-IT')}
                  <br />
                  <strong>{series[0].value}</strong> {unitOfMeasure}
                </small>
              </Typography>
            </div>
          )
        }
      }}
      sx={{
        '& .MuiAreaElement-root': {
          fill: 'rgba(25, 118, 210, 0.2)'
        }
      }}

    />
  )
}

export default NetworkChart
